import { SECONDS } from "@renproject/utils";
import Axios from "axios";
import { TerraNetwork } from "./deposit";
import { getHeight } from "./height";
const TERRA_DEV_URL = (network) => {
    let prefix;
    switch (network) {
        case TerraNetwork.Columbus:
            prefix = "fcd";
            break;
        case TerraNetwork.Tequila:
            prefix = "tequila-fcd";
            break;
        default:
            throw new Error(`Terra network ${String(network)} not supported.`);
    }
    return `https://${String(prefix)}.terra.dev/v1`;
};
const extractDepositsFromTx = (chainHeight) => (tx) => {
    const msgs = [];
    try {
        const decodedMsgs = tx.tx.value.msg;
        for (let i = 0; i < decodedMsgs.length; i++) {
            const msg = decodedMsgs[i];
            if (msg.type === "bank/MsgSend") {
                for (const amount of msg.value.amount) {
                    msgs.push({
                        ...tx,
                        messageIndex: i,
                        to_address: msg.value.to_address,
                        from_address: msg.value.from_address,
                        ...amount,
                    });
                }
            }
        }
    }
    catch (_error) {
        return [];
    }
    return msgs.map((msg) => {
        return {
            hash: msg.txhash,
            messageIndex: msg.messageIndex,
            from: msg.from_address,
            to: msg.to_address,
            denomination: msg.denom,
            amount: msg.amount,
            memo: msg.tx.value.memo,
            confirmations: msg.height
                ? chainHeight - parseInt(msg.height, 10)
                : msg.height,
        };
    });
};
const concat = (x, y) => x.concat(y);
const fetchDeposits = async (address, network, memo = undefined) => {
    // const paramsFilterBase64 = paramsFilter && paramsFilter.toString("base64");
    // const url = `${TERRA_DEV_URL(network)}/txs?account=${address}&page=${
    //     page + 1
    // }&chainId=${network}`;
    const url = `${TERRA_DEV_URL(network)}/txs?account=${address}&chainId=${network}`;
    const response = (await Axios.get(url, {
        timeout: 60 * SECONDS,
    })).data;
    const { txs } = response;
    const filteredTxs = !memo
        ? txs
        : txs.filter((message) => message.tx &&
            message.tx.value &&
            message.tx.value.memo === memo);
    // Create an entry for each message. Transactions can contain multiple
    // messages.
    // Fetch current height of the chain. Skip if no messages were found.
    const chainHeight = filteredTxs.length > 0 ? await getHeight(network) : 0;
    return filteredTxs
        .map(extractDepositsFromTx(chainHeight))
        .reduce(concat, [])
        .filter((msg) => msg.to === address);
};
const fetchDeposit = async (hash, messageIndex, network) => {
    // const paramsFilterBase64 = paramsFilter && paramsFilter.toString("base64");
    const url = `${TERRA_DEV_URL(network)}/tx/${hash}`;
    const tx = (await Axios.get(url, {
        timeout: 60 * SECONDS,
    })).data;
    if (tx === null) {
        throw new Error(`Unable to find Terra transaction ${hash}.`);
    }
    // Create an entry for each message. Transactions can contain multiple
    // messages.
    // Fetch current height of the chain. Skip if no messages were found.
    const chainHeight = await getHeight(network);
    return extractDepositsFromTx(chainHeight)(tx)[messageIndex];
};
export const terraDev = {
    fetchDeposits,
    fetchDeposit,
};
//# sourceMappingURL=terraDev.js.map